import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";
import { loftInsulationLp } from "@/content/landing/loft-insulation";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";
import { withServiceLcpPreload } from "@/lib/service-lcp-preload";
import { SERVICE_PAGE_OG_IMAGES } from "@/lib/service-page-og-images";

const LpLoftInsulationPage = lazyNamed(
  () => import("@/components/landing/lp-loft-insulation"),
  "LpLoftInsulation",
);

const PATH = "/loft-insulation";
const TITLE = "Loft Insulation South Wales | PAS 2030 Certified | CRS Energy";
const DESCRIPTION =
  "PAS 2030 certified loft insulation across South Wales. TrustMark registered, insurance-backed guarantee, free loft inspection and clear property-specific quotation.";

export const Route = createFileRoute("/loft-insulation")({
  head: () =>
    withServiceLcpPreload(PATH, {
    ...pageSeo({
      path: PATH,
      title: TITLE,
      description: DESCRIPTION,
      image: SERVICE_PAGE_OG_IMAGES[PATH],
      ogType: "article",
    }),
    scripts: [
      serviceJsonLdScript({
        name: "Loft Insulation",
        description: DESCRIPTION,
        serviceType: "Loft Insulation",
        url: `${SITE.url}${PATH}`,
        image: SERVICE_PAGE_OG_IMAGES[PATH],
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: loftInsulationLp.faqs.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
    ],
  }),
  component: LpLoftInsulationPage,
});
